export const RATIO_CODE = {
  INS_PREMIUM: 'IS1',
  REINS_PREMIUM: 'IS45',
  NET_INS_PREMIUM: 'IS51',
  INS_GROWTH: 'FA269',
  REINS_GROWTH: 'RT0418',
  NET_INS_GROWTH: 'RT0419',
}

export const TREND_DATA = [
  { value: RATIO_CODE.INS_PREMIUM, color: '#006AA6', isBarChart: true },
  { value: RATIO_CODE.REINS_PREMIUM, color: '#FFCD60', isBarChart: true },
  { value: RATIO_CODE.NET_INS_PREMIUM, color: '#FF596A', isBarChart: true },
  { value: RATIO_CODE.INS_GROWTH, color: '#4EB1CB', isLineChart: true },
  { value: RATIO_CODE.REINS_GROWTH, color: '#F49966', isLineChart: true },
  { value: RATIO_CODE.NET_INS_GROWTH, color: '#d96383', isLineChart: true },
]
